import React, { Component, Fragment } from "react";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import NumberFormat from "react-number-format";
import converter from "number-to-words";
export class PrintViewParadan extends Component {
 render() {
  const { change_Lang, view_paradan_obj, primary_logo_bill, lang } = this.props;
  let converter1 =
   view_paradan_obj.Amount && converter.toWords(view_paradan_obj.Amount);
  return (
   <Fragment>
    <br />
    <br />
    <br />
    <br /> <br />
    <br />
    <br />
    <div>
     <div class="row mt-3">
      <div class="col-4">
       <p
        style={{
         fontSize: "19px",
         color: "#000",
         textAlign: "left",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        &nbsp;&nbsp;{change_Lang("date")} :&nbsp;
        <Time
         value={view_paradan_obj.createdAt}
         format="hh:mm:ss"
         style={{
          fontSize: "19px",
          color: "#342800",
          fontWeight: "bold",
         }}
        />
        &nbsp;-{" "}
        <Time
         value={view_paradan_obj.createdAt}
         format="YYYY-MM-DD"
         style={{
          fontSize: "19px",
          color: "#000",
          fontWeight: "bold",
         }}
        />
       </p>
      </div>
      <div class="col-4 ">
       <p
        style={{
         fontSize: "17px",
         color: "black",
         fontWeight: "bold",
         margin: "0px 0px 0px 0px",
        }}
        class=" d-flex justify-content-center"
       >
        {change_Lang("Payment bills")}({change_Lang(view_paradan_obj.type)})
       </p>
      </div>
      <div class="col-4 text-right">
       <p
        style={{
         fontSize: "19px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        #No&nbsp;:
        {view_paradan_obj.invoice_No}&nbsp;
       </p>
      </div>
     </div>
     {/* first row */}
     <div
      class="row "
      style={{ width: "100%", backgroundColor: "#f4f4f6", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        وەرگر/المستلم :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fk col-form-label d-flex justify-content-start"
        style={{
         fontSize: "22px",
         color: "black",
        }}
       >
        {view_paradan_obj.payer}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label "
       >
        : Receptor
       </label>
      </div>
     </div>
     {/* second row */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "white", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        بڕی پارە / مبلغ و قدره :
       </label>
      </div>
      <div
       class="col-6 d-flex justify-content-center"
       style={{ direction: "ltr" }}
      >
       {" "}
       <NumberFormat
        displayType="text"
        thousandSeparator={true}
        value={view_paradan_obj.Amount}
        style={{
         fontSize: "22px",
         color: "black",
        }}
        className="col-form-label"
        prefix={`${view_paradan_obj.currency === "dolar" ? "$" : "ID"}`}
       />
       &nbsp;&nbsp;
       <span
        style={{ marginTop: "14px", fontWeight: "bold", fontSize: "15px" }}
       >
        {" "}
        {converter1}&nbsp;
        {view_paradan_obj.currency === "dolar" ? "US dollars" : "IQD Iraq"}
        {change_Lang("Only")}
       </span>
      </div>
      <div class="col-3 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label "
       >
        : Amount
       </label>
      </div>
     </div>
     {/* third row */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "#f4f4f6", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        لە بڕی / وذلك عن :
       </label>
      </div>
      <div class="col-8 d-flex justify-content-center">
       {view_paradan_obj.type !== "investor" &&
       view_paradan_obj.instead_of === "" ? (
        <>
         <span
          className="fk d-flex justify-content-center  mt-2"
          style={{
           fontSize: "20px",
           color: "black",
           textAlign: "justify",
          }}
         >
          {view_paradan_obj.type !== "Monthly rent invoice" ? (
           <>
            {change_Lang(view_paradan_obj.type)} (
            {change_Lang(view_paradan_obj.property)})&nbsp;
            {change_Lang("from")}
            &nbsp;({view_paradan_obj.place}) &nbsp;
            {change_Lang("Number")}&nbsp;({view_paradan_obj.num})
           </>
          ) : (
           <>
            {change_Lang(view_paradan_obj.type)} (
            {change_Lang(view_paradan_obj.property)})&nbsp;
            {change_Lang("from")}
            &nbsp;({view_paradan_obj.place}) &nbsp;
            {change_Lang("Number")}&nbsp;({view_paradan_obj.num}
            )&nbsp;
            {change_Lang("from")}&nbsp;
            {view_paradan_obj.from}
            &nbsp;
            {change_Lang("to")}&nbsp;
            {view_paradan_obj.to}
           </>
          )}
         </span>
        </>
       ) : (
        <span
         className="fk d-flex justify-content-center mt-2"
         style={{
          fontSize: "20px",
          color: "black",
          textAlign: "justify",
         }}
        >
         {view_paradan_obj && view_paradan_obj.instead_of}
        </span>
       )}
      </div>
      <div class="col-1 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label "
       >
        : For
       </label>
      </div>
     </div>
     {/* five row */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "white", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        پارەدەر / الدافع :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fk col-form-label"
        style={{
         fontSize: "22px",
         color: "black",
        }}
       >
        {view_paradan_obj.reciver}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label"
       >
        : The Payer
       </label>
      </div>
     </div>
     {/* note */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "#f4f4f6", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        تێبینی / الملاحظات :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fk col-form-label"
        style={{
         fontSize: "22px",
         color: "black",
        }}
       >
        {view_paradan_obj.note}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label"
       >
        : Note
       </label>
      </div>
     </div>
     {/* six row */}
     <br />
     <br /> <br /> <br />
     <div class="row">
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label"
       >
        (The payer)&nbsp;Signature
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
         fontWeight: "bold",
        }}
        class=" col-form-label"
       >
        (Receptor)&nbsp;Signature
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         textAlign: "center",
        }}
        class=" col-form-label"
       >
        {view_paradan_obj.reciver}
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         textAlign: "center",
        }}
        class=" col-form-label"
       >
        {view_paradan_obj.payer}
       </label>
      </div>
     </div>
    </div>
    <br />
    <br />
    <br />
    <br />
    <br />
    {/* Second Invoice */}
    <br />
    <br />
    <br /> <br />
    <br />
    <br />
    <br />
    <div>
     <div class="row mt-3">
      <div class="col-4">
       <p
        style={{
         fontSize: "19px",
         color: "#000",
         textAlign: "left",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        &nbsp;&nbsp;{change_Lang("date")} :&nbsp;
        <Time
         value={view_paradan_obj.createdAt}
         format="hh:mm:ss"
         style={{
          fontSize: "19px",
          color: "#342800",
          fontWeight: "bold",
         }}
        />
        &nbsp;-{" "}
        <Time
         value={view_paradan_obj.createdAt}
         format="YYYY-MM-DD"
         style={{
          fontSize: "19px",
          color: "#000",
          fontWeight: "bold",
         }}
        />
       </p>
      </div>
      <div class="col-4 ">
       <p
        style={{
         fontSize: "17px",
         color: "black",
         fontWeight: "bold",
         margin: "0px 0px 0px 0px",
        }}
        class=" d-flex justify-content-center"
       >
        {change_Lang("Payment bills")}({change_Lang(view_paradan_obj.type)})
       </p>
      </div>
      <div class="col-4 text-right">
       <p
        style={{
         fontSize: "19px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        #No&nbsp;:
        {view_paradan_obj.invoice_No}&nbsp;
       </p>
      </div>
     </div>
     {/* first row */}
     <div
      class="row "
      style={{ width: "100%", backgroundColor: "#f4f4f6", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        وەرگر/المستلم :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fk col-form-label d-flex justify-content-start"
        style={{
         fontSize: "22px",
         color: "black",
        }}
       >
        {view_paradan_obj.payer}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label "
       >
        : Receptor
       </label>
      </div>
     </div>
     {/* second row */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "white", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        بڕی پارە / مبلغ و قدره :
       </label>
      </div>
      <div
       class="col-6 d-flex justify-content-center"
       style={{ direction: "ltr" }}
      >
       {" "}
       <NumberFormat
        displayType="text"
        thousandSeparator={true}
        value={view_paradan_obj.Amount}
        style={{
         fontSize: "22px",
         color: "black",
        }}
        className="col-form-label"
        prefix={`${view_paradan_obj.currency === "dolar" ? "$" : "ID"}`}
       />
       &nbsp;&nbsp;
       <span
        style={{ marginTop: "14px", fontWeight: "bold", fontSize: "15px" }}
       >
        {" "}
        {converter1}&nbsp;
        {view_paradan_obj.currency === "dolar" ? "US dollars" : "IQD Iraq"}
        {change_Lang("Only")}
       </span>
      </div>
      <div class="col-3 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label "
       >
        : Amount
       </label>
      </div>
     </div>
     {/* third row */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "#f4f4f6", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        لە بڕی / وذلك عن :
       </label>
      </div>
      <div class="col-8 d-flex justify-content-center">
       {view_paradan_obj.type !== "investor" &&
       view_paradan_obj.instead_of === "" ? (
        <>
         <span
          className="fk d-flex justify-content-center  mt-2"
          style={{
           fontSize: "20px",
           color: "black",
           textAlign: "justify",
          }}
         >
          {view_paradan_obj.type !== "Monthly rent invoice" ? (
           <>
            {change_Lang(view_paradan_obj.type)} (
            {change_Lang(view_paradan_obj.property)})&nbsp;
            {change_Lang("from")}
            &nbsp;({view_paradan_obj.place}) &nbsp;
            {change_Lang("Number")}&nbsp;({view_paradan_obj.num})
           </>
          ) : (
           <>
            {change_Lang(view_paradan_obj.type)} (
            {change_Lang(view_paradan_obj.property)})&nbsp;
            {change_Lang("from")}
            &nbsp;({view_paradan_obj.place}) &nbsp;
            {change_Lang("Number")}&nbsp;({view_paradan_obj.num}
            )&nbsp;
            {change_Lang("from")}&nbsp;
            {view_paradan_obj.from}
            &nbsp;
            {change_Lang("to")}&nbsp;
            {view_paradan_obj.to}
           </>
          )}
         </span>
        </>
       ) : (
        <span
         className="fk d-flex justify-content-center mt-2"
         style={{
          fontSize: "20px",
          color: "black",
          textAlign: "justify",
         }}
        >
         {view_paradan_obj && view_paradan_obj.instead_of}
        </span>
       )}
      </div>
      <div class="col-1 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label "
       >
        : For
       </label>
      </div>
     </div>
     {/* five row */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "white", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        پارەدەر / الدافع :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fk col-form-label"
        style={{
         fontSize: "22px",
         color: "black",
        }}
       >
        {view_paradan_obj.reciver}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label"
       >
        : The Payer
       </label>
      </div>
     </div>
     {/* note */}
     <div
      class="row"
      style={{ width: "100%", backgroundColor: "#f4f4f6", direction: "rtl" }}
     >
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        تێبینی / الملاحظات :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fk col-form-label"
        style={{
         fontSize: "22px",
         color: "black",
        }}
       >
        {view_paradan_obj.note}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label"
       >
        : Note
       </label>
      </div>
     </div>
     {/* six row */}
     <br />
     <br />
     <br />
     <div class="row" style={{ width: "100%" }}>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label"
       >
        (The payer)&nbsp;Signature
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         fontWeight: "bold",
         fontWeight: "bold",
        }}
        class=" col-form-label"
       >
        (Receptor)&nbsp;Signature
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         textAlign: "center",
        }}
        class=" col-form-label"
       >
        {view_paradan_obj.reciver}
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "22px",
         color: "black",
         textAlign: "center",
        }}
        class=" col-form-label"
       >
        {view_paradan_obj.payer}
       </label>
      </div>
     </div>
    </div>
   </Fragment>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  view_paradan_obj: state.Invoice_Reducer.view_paradan_obj,
  index_Paradan: state.Invoice_Reducer.index_Paradan,
  user: state.AuthReducer.user,
  primary_logo_bill: state.HelperReducer.primary_logo_bill,
  footer_logo_bill: state.HelperReducer.footer_logo_bill,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintViewParadan);
